/**
 * Helpers for post-test review UI.
 */

/**
 * @param {Array<{ respuestasMezcladas?: Array<{ esCorrecta?: boolean, texto?: string }>, pregunta?: string }>} preguntasTest
 * @param {Record<number, number>} respuestasUsuario
 * @returns {Array<{ index: number, pregunta: string, answerText: string, isCorrect: boolean, esCorrecta: boolean }>}
 */
export function buildTestReviewRows(preguntasTest, respuestasUsuario) {
  if (!Array.isArray(preguntasTest)) return [];
  const answers =
    respuestasUsuario && typeof respuestasUsuario === "object" ? respuestasUsuario : {};

  return preguntasTest.map((rawP, idx) => {
    const p = rawP && typeof rawP === "object" ? rawP : {};
    const respIdx = answers[idx];
    const respuestasMezcladas = Array.isArray(p.respuestasMezcladas) ? p.respuestasMezcladas : [];
    const respIdxValid =
      Number.isInteger(respIdx) && respIdx >= 0 && respIdx < respuestasMezcladas.length;
    const chosen = respIdxValid ? respuestasMezcladas[respIdx] : undefined;
    const isCorrect =
      chosen &&
      typeof chosen === "object" &&
      chosen.esCorrecta === true;
    let answerText = "(sin respuesta)";
    if (respIdx !== undefined && !respIdxValid) {
      answerText = "(índice fuera de rango)";
    } else if (respIdxValid) {
      answerText =
        typeof chosen?.texto === "string" && chosen.texto.trim() !== ""
          ? chosen.texto
          : "(sin texto)";
    }

    return {
      index: idx,
      pregunta: typeof p.pregunta === "string" ? p.pregunta : "(vacía)",
      answerText,
      isCorrect: !!isCorrect,
      esCorrecta: !!isCorrect,
    };
  });
}

/**
 * @param {Array<{ esCorrecta?: boolean }>} rows
 * @returns {Array<{ esCorrecta?: boolean }>}
 */
export function filterFailedReviewRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((row) => row && row.esCorrecta !== true);
}

/**
 * @param {Array<{ respuestasMezcladas?: Array<{ esCorrecta?: boolean }> }>} preguntasTest
 * @param {Record<number, number>} respuestasUsuario
 * @returns {number[]}
 */
export function getFailedQuestionIndices(preguntasTest, respuestasUsuario) {
  if (!Array.isArray(preguntasTest)) return [];
  const answers =
    respuestasUsuario && typeof respuestasUsuario === "object" ? respuestasUsuario : {};
  const indices = [];
  preguntasTest.forEach((rawP, idx) => {
    const p = rawP && typeof rawP === "object" ? rawP : {};
    const respIdx = answers[idx];
    const respuestasMezcladas = Array.isArray(p.respuestasMezcladas) ? p.respuestasMezcladas : [];
    const chosen = respIdx !== undefined ? respuestasMezcladas[respIdx] : undefined;
    const isCorrect =
      chosen &&
      typeof chosen === "object" &&
      chosen.esCorrecta === true;
    if (!isCorrect) indices.push(idx);
  });
  return indices;
}

/**
 * @param {Array<{ respuestasMezcladas?: Array<{ esCorrecta?: boolean }> }>} preguntasTest
 * @param {Record<number, number>} respuestasUsuario
 * @returns {boolean}
 */
export function shouldConfirmLeaveTestResults(preguntasTest, respuestasUsuario) {
  return getFailedQuestionIndices(preguntasTest, respuestasUsuario).length > 0;
}
